import AllRoute from "./Routes/AllRoutes";

function App() {
  return (
    <div >
      <AllRoute />
      
    </div>
  );
}

export default App;
